import React from "react";

const FileEdit = ({
  size = 20,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 1.66797C17.1269 1.66797 17.5 2.04107 17.5 2.5013V5.63214L10.001 13.1315L9.99583 16.6638L13.5345 16.669L17.5 12.703V17.5013C17.5 17.9616 17.1269 18.3346 16.6667 18.3346H3.33333C2.8731 18.3346 2.5 17.9616 2.5 17.5013V2.5013C2.5 2.04107 2.8731 1.66797 3.33333 1.66797H16.6667ZM18.1485 7.34098L19.327 8.51947L12.8452 15.0013L11.6649 14.9996L11.6667 13.8228L18.1485 7.34098ZM10 10.0013H5.83333V11.668H10V10.0013ZM12.5 6.66797H5.83333V8.33464H12.5V6.66797Z"
        fill={color}
      />
    </svg>
  );
};

export default FileEdit;
